angular.module('impactx.approval').controller('ContractChangeListCtrl', ContractChangeListCtrl);

ContractChangeListCtrl.$inject = ['selectedListItems'];

function ContractChangeListCtrl(selectedListItems)
{
    var self = this;

    self.getDetailLink = function () {
        return 'contractchangedialog/' + selectedListItems.getFirstSelectedItem().atiId;
    };

    self.getProductLink = function () {
        return 'product/' + selectedListItems.getFirstSelectedItem().proId;
    }

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: self.getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: ''
        },
        {
            label: "product",
            linkFunction: self.getProductLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: ''
        }
    ];

    self.meta = {
        rowTemplate: 'modules/approval/templates/contractchange-list.row.tmpl.html',
        isSelectAble: true,
        ctrl: self,
        endpoint: '/approval/contractchange/list',
        id: "contractchange",
        excelExport: true,
        buttonDefinition: buttonDefinition
    };
    self.getMeta = function () {
        return self.meta;
    };
}